// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Adp0_r","footerContainer":"_4YQVmN"};